import { tpoDenialConfigurationApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TPO_DENIAL_CONFIGURATION_ACTION_TYPE = createNamedActions('tpoDenialConfiguration', {
  GET_CATEGORIES: 'GET_CATEGORIES',
  CREATE_CATEGORY: 'CREATE_CATEGORY',
  UPDATE_CATEGORY: 'UPDATE_CATEGORY',
  DELETE_CATEGORY: 'DELETE_CATEGORY',
  CREATE_REASON: 'CREATE_REASON',
  UPDATE_REASON: 'UPDATE_REASON',
  DELETE_REASON: 'DELETE_REASON',
});

export const getTpoDenialCategoriesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await tpoDenialConfigurationApi.getCategories();

  return dispatch({
    type: TPO_DENIAL_CONFIGURATION_ACTION_TYPE.GET_CATEGORIES,
    payload: data,
  });
});

export const createTpoDenialCategoryAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tpoDenialConfigurationApi.createCategory(params);

  return dispatch({
    type: TPO_DENIAL_CONFIGURATION_ACTION_TYPE.CREATE_CATEGORY,
    payload: data,
  });
});

export const updateTpoDenialCategoryAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tpoDenialConfigurationApi.updateCategory(params);

  return dispatch({
    type: TPO_DENIAL_CONFIGURATION_ACTION_TYPE.UPDATE_CATEGORY,
    payload: data,
  });
});

export const deleteTpoDenialCategoryAction = catchAsyncActionError(
  ({ categoryId }) =>
    async dispatch => {
      await tpoDenialConfigurationApi.deleteCategory({ categoryId });

      return dispatch({
        type: TPO_DENIAL_CONFIGURATION_ACTION_TYPE.DELETE_CATEGORY,
        payload: { categoryId },
      });
    },
);

export const createTpoDenialReasonAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tpoDenialConfigurationApi.createReason(params);

  return dispatch({
    type: TPO_DENIAL_CONFIGURATION_ACTION_TYPE.CREATE_REASON,
    payload: data,
  });
});

export const updateTpoDenialReasonAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await tpoDenialConfigurationApi.updateReason(params);

  return dispatch({
    type: TPO_DENIAL_CONFIGURATION_ACTION_TYPE.UPDATE_REASON,
    payload: data,
  });
});

export const deleteTpoDenialReasonAction = catchAsyncActionError(
  ({ categoryId, reasonId }) =>
    async dispatch => {
      await tpoDenialConfigurationApi.deleteReason({ categoryId, reasonId });

      return dispatch({
        type: TPO_DENIAL_CONFIGURATION_ACTION_TYPE.DELETE_REASON,
        payload: { categoryId, reasonId },
      });
    },
);
